





















































































































import { Vue, Prop,Component } from 'vue-property-decorator';
import PlayLottie from '@/views/searchSpeaker/components/playLottie/playLottie.vue';

@Component({
  components: {
    PlayLottie
  },
})
export default class MusicCards extends Vue {
  @Prop({ default: [] })
  musicList: Array<any>;

  @Prop({ default: false })
  editable: Boolean;

  @Prop({ default: '' })
  musicType: String;
  created(){
    console.log('music00',this.musicList)
  }
  mounted() {
    console.log('mounted',this.$props.musicList)
  }
  musicReady = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/moyin-mp-cdn/cdnData/images/music_ready_1703500015444.png';
  musicPlay = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/moyin-mp-cdn/cdnData/images/music_play_1703499946293.png';
  currMusicId = 0; //当前选中的背景音id
  isMusicListing = false; //背景音是否在试听
  //收藏-第一版本暂不使用
  collect (id, idx){
    this.musicList = this.musicList.map( item => {
      if (item.id === id) {
        item.isCollect = !item.isCollect;
      }
      return item;
    });
    //调用接口--todo
  };
  chooseMusic(item) {
    console.log('---item', item.id, this.currMusicId, this.isMusicListing);
    if (this.currMusicId === item.id && this.isMusicListing) {
      this.$emit('bgmStop')
      this.isMusicListing = false;
    } else {
      this.currMusicId = item.id;
      this.isMusicListing = true;
      this.$emit('bgmPlay',item.url)
      this.$emit('setCurrBgm',item);//只有背景音改变时才触发
    }
  };
  deleteItem(item){
    console.log('---deleteItem item', item.id);
    this.$emit('deleteItem',item.id)
  }
  parseMillsTime(time: any) {
    var min:any = parseInt((time / 1000 / 60) as any);
    var sec:any = parseInt((time / 1000 ) % 60 as any);
    if (min < 10) {
      min = '0' + min;
    }
    if (sec < 10) {
      sec = '0' + sec;
    }
    // console.log('-------ttt',min, sec);
    return min + ':' + sec;
  }
}
